import {Controller} from '@stimulus/core'
import HSVideoBg from '../../../../../vendor/front/vendor/hs-video-player/src/js/hs-video-player'

// data-controller='hs--video-player'

export default class extends Controller {
  connect() {
    new HSVideoBg($(this.element)).init()
  }
}
